<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M13.3 26.7H26.6V25.6H13.3V26.7ZM13.3 20.55H34.7V19.45H13.3V20.55ZM13.3 14.4H31.3V14.45C31.2 14.2167 31.125 14.0083 31.075 13.825C31.025 13.6417 30.9667 13.4667 30.9 13.3H13.3V14.4ZM6.60001 39V9.3C6.60001 8.54067 6.86017 7.90083 7.38051 7.3805C7.90117 6.86017 8.54101 6.6 9.30001 6.6H29.7C29.6333 6.76667 29.575 6.94167 29.525 7.125C29.475 7.30833 29.4333 7.5 29.4 7.7H9.30001C8.90001 7.7 8.53334 7.86667 8.20001 8.2C7.86667 8.53333 7.70001 8.9 7.70001 9.3V36.4L11.7 32.3H38.7C39.1 32.3 39.4667 32.1333 39.8 31.8C40.1333 31.4667 40.3 31.1 40.3 30.7V16.85C40.493 16.8167 40.6747 16.7667 40.845 16.7C41.015 16.6333 41.2 16.55 41.4 16.45V30.7C41.4 31.459 41.1398 32.0988 40.6195 32.6195C40.0992 33.1398 39.4593 33.4 38.7 33.4H12.2L6.60001 39ZM7.70001 9.3V35.9V7.7V9.3ZM37.991 13.2C36.7303 13.2 35.6583 12.7553 34.775 11.866C33.8917 10.977 33.45 9.902 33.45 8.641C33.45 7.38033 33.8947 6.30833 34.784 5.425C35.673 4.54167 36.748 4.1 38.009 4.1C39.2697 4.1 40.3417 4.54467 41.225 5.434C42.1083 6.323 42.55 7.398 42.55 8.659C42.55 9.91967 42.1053 10.9917 41.216 11.875C40.327 12.7583 39.252 13.2 37.991 13.2Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>